import PageCardList from './PageCardList';

export default PageCardList;
